import React from 'react';

/**
 * LMS Contact US component's props definitions.
 * @param {string} className - CSS class for the button.
 * @param {boolean} useCustomStyles - Determines styles used for the button.
 * @param {function} onClick - Click event handler for the button.
 */
interface LmsContactUsProps {
    className?: string;
    useCustomStyles?: boolean;
    onClick?: () => void;
}

/**
 * This component is used for displaying button which connected with Whatsapp Admin
 */
const LmsContactUs: React.FC<LmsContactUsProps> = ({ className, useCustomStyles, onClick }) => {
    const defaultStyles =
        'text-sm sm:text-base font-semibold font-body text-white bg-accent-100 py-2 px-4 sm:px-8 sm:py-3 rounded transition duration-300 ease-out hover:bg-white hover:text-accent-100';

    const customStyles =
        'text-sm sm:text-base font-semibold font-body text-white bg-accent-100 py-2 px-4 sm:px-8 sm:py-3 rounded transition duration-300 ease-out hover:bg-secondary-100 hover:text-white';

    const handleClick = () => {
        const phoneNumber = '6281215636018';
        const introduction = 'Halo Mindu 1, perkenalkan saya';
        const name = 'Nama:';
        const statement = 'Pertanyaan: ';
        const message = `${introduction}\n${name}\n${statement}`;
        const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        window.open(whatsappURL, '_blank');
    };

    const combinedClassName = className
        ? `${useCustomStyles ? customStyles : defaultStyles} ${className}`
        : useCustomStyles
            ? customStyles
            : defaultStyles;

    return (
        <button className={combinedClassName} onClick={onClick || handleClick}>
            HUBUNGI KAMI
        </button>
    );
};

export default LmsContactUs;